/**
 * The user's place to display next to their tournament points. Places are
 * shared on ties (1 + participants with more points), so before anyone scores
 * every participant is "#1" — hidden until the user has points.
 */
export function visibleRank(
  rank: number | null | undefined,
  points: number | string | null | undefined,
): number | null {
  if (rank == null) return null;
  return Number(points ?? 0) > 0 ? rank : null;
}
